(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bento"] && !Shopify.designMode) return;
  try {
    
  /* phones: dots follow the photo row's swipe */
  document.querySelectorAll('[data-swipe-row]').forEach((row) => {
    const dots = row.nextElementSibling;
    if (!dots || !dots.matches('[data-swipe-dots]')) return;
    const n = row.children.length;
    if (n < 2) return;
    dots.innerHTML = '<i></i>'.repeat(n);
    const items = [...dots.children];
    let raf = 0;
    const sync = () => {
      raf = 0;
      const w = row.children[1].offsetLeft - row.children[0].offsetLeft || 1;
      const end = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
      const k = end ? n - 1 : Math.round(row.scrollLeft / w);
      items.forEach((d, j) => d.classList.toggle('is-on', j === k));
    };
    row.addEventListener('scroll', () => raf || (raf = requestAnimationFrame(sync)), { passive: true });
    sync();
  });
  (() => {
    if (customElements.get('stage-grid')) return;
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    customElements.define(
      'stage-grid',
      class extends HTMLElement {
        connectedCallback() {
          if (!fine) return;
          const panel = this.closest('.stg__panel');
          let raf = 0;
          panel.addEventListener('pointermove', (e) => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() =>
              panel.querySelectorAll('.stg__tile').forEach((t) => {
                const r = t.getBoundingClientRect();
                const x = e.clientX - r.left;
                const y = e.clientY - r.top;
                t.style.setProperty('--mx', x + 'px');
                t.style.setProperty('--my', y + 'px');
                const inside = x >= 0 && y >= 0 && x <= r.width && y <= r.height;
                t.style.setProperty('--rx', inside ? ((x / r.width) * 2 - 1).toFixed(3) : 0);
                t.style.setProperty('--ry', inside ? ((y / r.height) * 2 - 1).toFixed(3) : 0);
              })
            );
          });
          panel.addEventListener('pointerleave', () => panel.querySelectorAll('.stg__tile').forEach((t) => { t.style.setProperty('--rx', 0); t.style.setProperty('--ry', 0); }));
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('compare-table')) return;
    customElements.define(
      'compare-table',
      class extends HTMLElement {
        connectedCallback() {
          if (!('IntersectionObserver' in window)) return this.classList.add('is-in');
          const io = new IntersectionObserver(
            ([e]) => {
              if (!e.isIntersecting) return;
              this.classList.add('is-in');
              io.disconnect();
            },
            { threshold: 0.3 }
          );
          io.observe(this);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cookie-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('cookie-bar')) return;
    customElements.define(
      'cookie-bar',
      class extends HTMLElement {
        connectedCallback() {
          this.querySelector('[data-accept]').addEventListener('click', () => this.save({ analytics: true, marketing: true, preferences: true, sale_of_data: true }));
          this.querySelector('[data-decline]').addEventListener('click', () => this.save({ analytics: false, marketing: false, preferences: false, sale_of_data: false }));
          this.querySelector('[data-more]').addEventListener('click', () => {
            this.querySelector('[data-prefs]').hidden = false;
            this.querySelector('[data-save]').hidden = false;
            this.querySelector('[data-more]').hidden = true;
          });
          this.querySelector('[data-save]').addEventListener('click', () => {
            const pick = (p) => Boolean(this.querySelector(`[data-purpose="${p}"]`)?.checked);
            this.save({ analytics: pick('analytics'), marketing: pick('marketing'), preferences: pick('preferences'), sale_of_data: pick('marketing') });
          });
          if (this.dataset.preview === 'true') {
            this.hidden = false;
            return;
          }
          /* asked once: after it has been shown (or answered) it never comes back on the next page */
          const KEY = 'cookie-bar-seen';
          let seen = null;
          try { seen = localStorage.getItem(KEY); } catch (e) {}
          if (seen) return;
          const remember = () => { try { localStorage.setItem(KEY, String(Date.now())); } catch (e) {} };
          new MutationObserver(() => { if (!this.hidden) remember(); }).observe(this, { attributes: true, attributeFilter: ['hidden'] });
          /* ask Shopify whether this visitor needs to be asked */
          const native = () => document.getElementById('shopify-pc__banner');
          const ready = () => {
            const cp = window.Shopify?.customerPrivacy;
            const ask = cp?.shouldShowBanner ? cp.shouldShowBanner() : cp?.shouldShowGDPRBanner?.();
            /* Shopify's own banner is switched on too: never show two */
            setTimeout(() => (this.hidden = !ask || Boolean(native())), 1200);
            new MutationObserver((_, mo) => {
              if (!native()) return;
              this.hidden = true;
              mo.disconnect();
            }).observe(document.body, { childList: true });
          };
          if (window.Shopify?.customerPrivacy) ready();
          else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (err) => !err && ready());
        }
        save(consent) {
          const cp = window.Shopify?.customerPrivacy;
          try { localStorage.setItem('cookie-bar-seen', String(Date.now())); } catch (e) {}
          this.hidden = true;
          cp?.setTrackingConsent?.(consent, () => document.dispatchEvent(new CustomEvent('consent:changed', { detail: consent })));
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cta-bloom"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('cta-aurora')) return;
    const fine = window.matchMedia('(hover: hover)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    customElements.define(
      'cta-aurora',
      class extends HTMLElement {
        connectedCallback() {
          /* scroll progress through the panel drives the words and the product */
          if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            let on = false;
            let ticking = false;
            const paint = () => {
              ticking = false;
              const r = this.getBoundingClientRect();
              const vh = window.innerHeight;
              this.style.setProperty('--cs', Math.max(0, Math.min(1, (vh - r.top) / (vh + r.height))).toFixed(3));
            };
            new IntersectionObserver(([x]) => {
              on = x.isIntersecting;
              if (on) paint();
            }).observe(this);
            window.addEventListener('scroll', () => on && !ticking && (ticking = true) && requestAnimationFrame(paint), { passive: true });
          }
          if (!fine) return;
          let raf = 0;
          this.addEventListener('pointermove', (e) => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(() => {
              const r = this.getBoundingClientRect();
              const x = (e.clientX - r.left) / r.width;
              const y = (e.clientY - r.top) / r.height;
              this.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
              this.style.setProperty('--my', (y * 100).toFixed(1) + '%');
              this.style.setProperty('--ax', (x * 2 - 1).toFixed(3));
              this.style.setProperty('--ay', (y * 2 - 1).toFixed(3));
            });
          });
          this.addEventListener('pointerleave', () => ['--ax', '--ay'].forEach((k) => this.style.setProperty(k, 0)));
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["help-assistant"] && !Shopify.designMode) return;
  try {
    
  /* Opens the panel; the answer engine (assets/help.js) loads on first open. */
  (() => {
    if (customElements.get('help-assistant')) return;
    customElements.define(
      'help-assistant',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.querySelectorAll('[data-help-open]').forEach((b) => b.addEventListener('click', () => this.open()));
          /* one-time hint bubble */
          const hint = this.querySelector('[data-hint]');
          const HINT = 'halden:support-hint';
          let seen = false;
          try {
            seen = localStorage.getItem(HINT) === '1';
          } catch (e) {}
          const dismiss = () => {
            if (hint) hint.hidden = true;
            try {
              localStorage.setItem(HINT, '1');
            } catch (e) {}
          };
          this.querySelector('[data-hint-close]')?.addEventListener('click', dismiss);
          if (hint && !seen && !window.Shopify?.designMode) {
            setTimeout(() => {
              if (!document.querySelector('dialog[open]')) hint.hidden = false;
            }, (Number(this.dataset.hintDelay) || 10) * 1000);
          }
          this.dismissHint = dismiss;
          this.dialog.addEventListener('click', (e) => e.target === this.dialog && this.dialog.close());
          /* other parts of the theme (footer link, tracking section) can open it */
          document.addEventListener('help:open', (e) => this.open(e.detail?.intent, e.detail?.ask));
          /* inline boxes (FAQ "Ask anything") ask the same engine */
          window.HaldenAsk = async (text) => {
            await this.load();
            return this.engine?.answer(text);
          };

        }
        async load() {
          if (this.engine) return;
          try {
            await import(this.dataset.src);
            this.engine = window.HaldenHelp?.mount(this);
          } catch (err) {}
        }
        async open(intent, ask) {
          this.dismissHint?.();
          if (!this.dialog.open) this.dialog.showModal();
          await this.load();
          if (!this.engine) return;
          if (ask) this.engine.handle(ask);
          else if (intent) this.engine?.intent(intent);
          else if (window.matchMedia('(min-width: 750px)').matches) this.querySelector('[data-input]')?.focus();
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-lifestyle"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hero-lifestyle')) return;
    customElements.define(
      'hero-lifestyle',
      class extends HTMLElement {
        connectedCallback() {
          /* headline words rise in one by one (italic accent stays one piece) */
          const title = this.querySelector('[data-words]');
          if (title && this.classList.contains('hlx--motion') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            let w = 0;
            [...title.childNodes].forEach((n) => {
              if (n.nodeType === 3) {
                const frag = document.createDocumentFragment();
                n.textContent.split(/(\s+)/).forEach((part) => {
                  if (!part) return;
                  if (/^\s+$/.test(part)) return frag.appendChild(document.createTextNode(part));
                  const span = document.createElement('span');
                  span.className = 'hlx__w';
                  span.style.setProperty('--w', w++);
                  span.textContent = part;
                  frag.appendChild(span);
                });
                n.replaceWith(frag);
              } else if (n.nodeType === 1) {
                n.classList.add('hlx__w');
                n.style.setProperty('--w', w++);
              }
            });
            this.classList.add('is-split');
          }
          /* tap the hotspot to open its card (hover does it with a mouse) */
          const spot = this.querySelector('.hlx__spot');
          const dot = spot?.querySelector('.hlx__dot');
          dot?.addEventListener('click', () => {
            const open = spot.classList.toggle('is-open');
            dot.setAttribute('aria-expanded', open);
          });
          let lastW = window.innerWidth;
          window.addEventListener('resize', () => {
            if (window.innerWidth === lastW) return;
            lastW = window.innerWidth;
            const t = this.getBoundingClientRect().top + window.scrollY;
            this.style.setProperty('--hlx-h', Math.max(600, window.innerHeight - t) + 'px');
          });
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hero-showcase')) return;
    customElements.define(
      'hero-showcase',
      class extends HTMLElement {
        connectedCallback() {
          let lastW = window.innerWidth;
          window.addEventListener('resize', () => {
            if (window.innerWidth === lastW) return;
            lastW = window.innerWidth;
            const t = this.getBoundingClientRect().top + window.scrollY;
            this.style.setProperty('--hs-h', Math.max(560, window.innerHeight - t) + 'px');
          });
          /* color swatches: swap the cut-out, the stage color and the link */
          const box = this.querySelector('.hs__product');
          const buy = this.querySelector('.hs__buy');
          const name = this.querySelector('[data-sw-name]');
          const dots = [...this.querySelectorAll('.hs-sw__dot')];
          const warm = () => dots.forEach((d) => d.dataset.swSrc && (new Image().src = d.dataset.swSrc));
          dots.forEach((d) => {
            d.addEventListener('pointerenter', warm, { once: true });
            d.addEventListener('click', () => {
              if (d.getAttribute('aria-pressed') === 'true') return;
              dots.forEach((x) => x.setAttribute('aria-pressed', x === d));
              if (name) name.textContent = d.dataset.swLabel;
              if (d.dataset.swStage) this.style.setProperty('--hs-stage', d.dataset.swStage);
              if (d.dataset.swHref && buy) buy.href = d.dataset.swHref;
              const src = d.dataset.swSrc;
              if (!src || !box) return;
              box.classList.add('is-swapping');
              const pre = new Image();
              pre.onload = pre.onerror = () =>
                setTimeout(() => {
                  box.querySelectorAll('img').forEach((im) => {
                    im.removeAttribute('srcset');
                    im.src = src;
                  });
                  box.classList.remove('is-swapping');
                }, 220);
              pre.src = src;
            });
          });
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-world"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hero-world')) return;
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    customElements.define(
      'hero-world',
      class extends HTMLElement {
        connectedCallback() {
          const char = this.querySelector('.hw__char');
          const bubble = this.querySelector('.hw__bubble');
          const lines = (bubble?.dataset.lines || '').split('|').map((l) => l.trim()).filter(Boolean);
          let line = 0;
          this.querySelector('.hw__char-img')?.addEventListener('click', () => {
            if (!calm) {
              char.classList.remove('is-hop');
              void char.offsetWidth;
              char.classList.add('is-hop');
            }
            if (bubble && lines.length > 1) {
              line = (line + 1) % lines.length;
              bubble.textContent = lines[line];
              bubble.classList.remove('is-new');
              void bubble.offsetWidth;
              bubble.classList.add('is-new');
            }
          });
          char?.addEventListener('animationend', (e) => e.animationName === 'hw-hop' && char.classList.remove('is-hop'));
          if (calm) return;
          this.classList.add('is-motion');
          let raf = 0;
          const set = (x, y) => {
            this.style.setProperty('--hw-x', x.toFixed(3));
            this.style.setProperty('--hw-y', y.toFixed(3));
          };
          if (fine) {
            this.addEventListener('pointermove', (e) => {
              if (raf) return;
              raf = requestAnimationFrame(() => {
                raf = 0;
                const r = this.getBoundingClientRect();
                set(((e.clientX - r.left) / r.width) * 2 - 1, ((e.clientY - r.top) / r.height) * 2 - 1);
              });
            });
            this.addEventListener('pointerleave', () => set(0, 0));
          } else {
            /* phones: depth follows the scroll while the hero is on screen */
            let on = true;
            new IntersectionObserver(([e]) => (on = e.isIntersecting)).observe(this);
            window.addEventListener(
              'scroll',
              () => {
                if (!on || raf) return;
                raf = requestAnimationFrame(() => {
                  raf = 0;
                  set(0, -Math.min(1.4, window.scrollY / (this.offsetHeight * 0.6)));
                });
              },
              { passive: true }
            );
          }
          let lastW = window.innerWidth;
          window.addEventListener('resize', () => {
            if (window.innerWidth === lastW) return;
            lastW = window.innerWidth;
            const t = this.getBoundingClientRect().top + window.scrollY;
            this.style.setProperty('--hw-h', Math.max(560, window.innerHeight - t) + 'px');
          });
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* stacked cards: while the next card slides over one, it settles back (scale) a little */
    if (!customElements.get('how-stack')) customElements.define('how-stack', class extends HTMLElement {
      connectedCallback() {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.cards = [...this.querySelectorAll('.how__card')];
        let raf = 0;
        let on = false;
        const tick = () => {
          raf = 0;
          for (let i = 0; i < this.cards.length - 1; i++) {
            const a = this.cards[i].getBoundingClientRect();
            const b = this.cards[i + 1].getBoundingClientRect();
            const p = Math.min(1, Math.max(0, 1 - (b.top - a.top) / a.height));
            this.cards[i].style.setProperty('--p', p.toFixed(3));
          }
        };
        const ask = () => on && !raf && (raf = requestAnimationFrame(tick));
        new IntersectionObserver(([e]) => { on = e.isIntersecting; ask(); }).observe(this);
        addEventListener('scroll', ask, { passive: true });
        addEventListener('resize', ask, { passive: true });
      }
    });
    if (customElements.get('how-deck')) return;
    /* step deck: the active step faces you; auto-advances while on screen; tap, swipe or the numbers choose */
    customElements.define('how-deck', class extends HTMLElement {
      connectedCallback() {
        this.cards = [...this.querySelectorAll('.how__card')];
        this.nodes = [...this.querySelectorAll('.how__node')];
        this.fill = this.querySelector('.how__track i');
        const n = this.cards.length;
        if (!n) return;
        const secs = parseFloat(getComputedStyle(this).getPropertyValue('--how-t')) || 5;
        const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.i = 0;
        const show = (k) => {
          this.i = (k + n) % n;
          this.cards.forEach((c, j) => {
            const d = j - this.i, ad = Math.abs(d);
            c.style.setProperty('--d', d);
            c.style.setProperty('--ad', ad);
            c.style.setProperty('--z', 10 - ad);
            c.classList.toggle('is-on', d === 0);
          });
          this.nodes.forEach((nd, j) => { nd.classList.toggle('is-on', j === this.i); nd.classList.toggle('is-done', j < this.i); });
          if (this.fill) this.fill.parentElement.parentElement.style.setProperty('--fill', n > 1 ? this.i / (n - 1) : 1);
          if (this.fill) this.fill.style.transform = `scaleX(${n > 1 ? this.i / (n - 1) : 1})`;
        };
        const go = (k) => { show(k); this.last = performance.now(); };
        this.cards.forEach((c, j) => c.addEventListener('click', () => go(j)));
        this.nodes.forEach((nd, j) => { nd.style.cursor = 'pointer'; nd.addEventListener('click', () => go(j)); });
        let sx = 0, sy = 0;
        this.addEventListener('pointerdown', (e) => { sx = e.clientX; sy = e.clientY; });
        this.addEventListener('pointerup', (e) => {
          const dx = e.clientX - sx;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(e.clientY - sy)) go(this.i + (dx < 0 ? 1 : -1));
        });
        show(0);
        if (calm) return;
        let on = false;
        new IntersectionObserver(([e]) => { on = e.isIntersecting; if (on) this.last = performance.now(); }, { threshold: 0.4 }).observe(this);
        this.last = performance.now();
        setInterval(() => { if (on && performance.now() - this.last > secs * 1000) go(this.i + 1); }, 400);
      }
    });
  })();

  (() => {
    if (customElements.get('how-steps')) return;
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const phone = window.matchMedia('(max-width: 749px)');
    customElements.define(
      'how-steps',
      class extends HTMLElement {
        connectedCallback() {
          this.cards = [...this.querySelectorAll('[data-card]')];
          this.nodes = [...this.querySelectorAll('[data-node]')];
          this.row = this.querySelector('.how__cards');
          this.i = 0;
          this.show(0);
          const t = (parseFloat(getComputedStyle(this).getPropertyValue('--how-t')) || 5) * 1000;
          const pick = (k, user) => {
            this.show(k);
            if (user) this.restart();
          };
          this.cards.forEach((c, k) => {
            c.addEventListener('click', () => !phone.matches && pick(k, true));
            c.addEventListener('mouseenter', () => !phone.matches && pick(k, true));
          });
          this.nodes.forEach((n, k) =>
            n.addEventListener('click', () => {
              if (phone.matches) this.row.scrollTo({ left: this.cards[k].offsetLeft - this.cards[0].offsetLeft, behavior: 'smooth' });
              else pick(k, true);
            })
          );
          /* phones: the rail follows the swipe */
          let raf = 0;
          this.row.addEventListener(
            'scroll',
            () => {
              if (!phone.matches || raf) return;
              raf = requestAnimationFrame(() => {
                raf = 0;
                const w = this.cards[1] ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : 1;
                this.show(Math.round(this.row.scrollLeft / w));
              });
            },
            { passive: true }
          );
          if (calm || this.cards.length < 2) return;
          this.tick = () => {
            clearTimeout(this.timer);
            if (!this.inView || phone.matches) return;
            this.timer = setTimeout(() => {
              this.show((this.i + 1) % this.cards.length);
              this.tick();
            }, t);
          };
          this.restart = () => this.tick();
          new IntersectionObserver(
            ([e]) => {
              this.inView = e.isIntersecting;
              this.classList.toggle('is-playing', e.isIntersecting && !phone.matches);
              this.tick();
            },
            { threshold: 0.35 }
          ).observe(this);
        }
        restart() {}
        show(k) {
          k = Math.max(0, Math.min(this.cards.length - 1, k));
          this.i = k;
          const n = this.cards.length;
          this.style.setProperty('--fill', n > 1 ? k / (n - 1) : 1);
          this.cards.forEach((c, j) => {
            c.classList.toggle('is-on', j === k);
            const v = c.querySelector('video');
            if (v) j === k ? v.play().catch(() => {}) : v.pause();
          });
          this.nodes.forEach((d, j) => {
            d.classList.toggle('is-on', j === k);
            d.classList.toggle('is-done', j < k);
          });
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["living-world"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('living-world')) return;
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
    const ease = (a, b, v) => { const t = clamp((v - a) / (b - a)); return t * t * (3 - 2 * t); };
    customElements.define(
      'living-world',
      class extends HTMLElement {
        connectedCallback() {
          const header = document.querySelector('.header--sticky');
          this.style.setProperty('--hwx-t', (header ? header.offsetHeight : 0) + 'px');
          this.beats = Number(this.dataset.beats) || 1;
          this.eyes = [...this.querySelectorAll('.hwx__eye')];
          this.bubble = this.querySelector('.hwx__bubble');
          this.lines = (this.bubble?.dataset.lines || '').split('|').map((l) => l.trim()).filter(Boolean);
          this.line = 0;
          this.querySelector('.hwx__poke')?.addEventListener('click', () => this.poke());
          /* the artwork can't be saved with a right click or a long press */
          this.querySelector('.hwx__stage')?.addEventListener('contextmenu', (e) => e.preventDefault());
          if (calm) {
            this.classList.add('is-pulled', 'is-revealed');
            return;
          }
          this.classList.add('is-motion');
          new IntersectionObserver(([e]) => {
            this.live = e.isIntersecting;
            this.classList.toggle('is-live', this.live);
          }).observe(this);
          if (this.classList.contains('hwx--film')) this.opening();
          else { this.classList.add('is-pulled'); this.reveal(); }
          /* eyes and depth follow the pointer; on phones the eyes follow a touch, otherwise they glance around */
          this.look = { x: 0, y: 0 };
          const point = (cx, cy) => {
            const eye = this.eyes[0];
            if (eye) {
              const r = eye.getBoundingClientRect();
              const dx = cx - (r.left + r.width / 2), dy = cy - (r.top + r.height / 2);
              const d = Math.max(1, Math.hypot(dx, dy));
              const k = clamp(d / 260);
              this.look = { x: (dx / d) * k, y: (dy / d) * k };
            }
            const h = this.getBoundingClientRect();
            if (fine) {
              this.style.setProperty('--lx', (((cx - h.left) / h.width) * 2 - 1).toFixed(3));
              this.style.setProperty('--ly', (((cy - h.top) / h.height) * 2 - 1).toFixed(3));
            }
            this.lastPoint = performance.now();
          };
          if (fine) window.addEventListener('pointermove', (e) => this.live && point(e.clientX, e.clientY), { passive: true });
          this.addEventListener('touchstart', (e) => point(e.touches[0].clientX, e.touches[0].clientY), { passive: true });
          this.addEventListener('touchmove', (e) => point(e.touches[0].clientX, e.touches[0].clientY), { passive: true });
          window.addEventListener('scroll', () => this.onScroll(), { passive: true });
          this.onScroll();
          this.nextGlance = performance.now() + 1800;
          const tick = (now) => {
            requestAnimationFrame(tick);
            if (!this.live || !this.eyes.length) return;
            if (now - (this.lastPoint || 0) > 2500 && now > this.nextGlance) {
              const a = Math.random() * Math.PI * 2, k = Math.random() * 0.9;
              this.look = { x: Math.cos(a) * k, y: Math.sin(a) * k * 0.6 };
              this.nextGlance = now + 1400 + Math.random() * 2200;
            }
            this.eyes.forEach((e) => {
              e.style.setProperty('--ex', this.look.x.toFixed(3));
              e.style.setProperty('--ey', this.look.y.toFixed(3));
            });
          };
          requestAnimationFrame(tick);
        }
        /* the opening film: starts loading at once, plays over its own sharp first frame, then hands over to the picture */
        opening() {
          if (!this.classList.contains('hwx--film')) return this.classList.add('is-pulled');
          const done = () => {
            if (this.classList.contains('is-pulled')) return;
            this.classList.add('is-pulled');
            /* no burst: just hand over to the picture; burst: the film's last frame stays until the flash */
            if (!this.classList.contains('hwx--burst')) setTimeout(() => this.classList.remove('is-playing'), 60);
            this.reveal();
          };
          if (scrollY > 60) return done();
          const film = this.querySelector('.hwx__film');
          const list = (this.dataset.film || '').split('|').map((x) => x.trim()).filter(Boolean).map((x) => (x.includes(' ') ? x.split(/\s+/) : ['1080', x]));
          const want = innerWidth < 750 ? 720 : 1080;
          list.sort((a, b) => Math.abs(a[0] - want) - Math.abs(b[0] - want));
          const save = navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''));
          if (!film || !list.length || save) return done();
          let started = false;
          const fallback = setTimeout(() => { if (!started) { film.pause(); done(); } }, 5000);
          film.src = list[0][1];
          let begun = false;
          const begin = () => { if (begun) return; begun = true; film.play().catch(() => { clearTimeout(fallback); done(); }); };
          film.addEventListener('canplaythrough', begin, { once: true });
          setTimeout(begin, 2200);
          film.addEventListener('playing', () => {
            if (started) return;
            started = true;
            clearTimeout(fallback);
            this.classList.add('is-playing');
          });
          film.addEventListener('ended', done);
          film.addEventListener('error', () => { clearTimeout(fallback); done(); });
          film.load();
          const skip = () => { if (scrollY > 80) { film.pause(); done(); removeEventListener('scroll', skip); } };
          addEventListener('scroll', skip, { passive: true });
        }
        onScroll() {
          const next = this.closest("[id^='shopify-section-']")?.nextElementSibling;
          if (next) {
            const t = next.getBoundingClientRect().top;
            this.style.setProperty('--out', clamp(1 - t / innerHeight).toFixed(3));
          }
          if (this.beats < 2) return;
          const r = this.getBoundingClientRect();
          const run = Math.max(1, this.offsetHeight - this.firstElementChild.offsetHeight);
          const p = clamp(-r.top / run);
          const b2 = ease(0.18, 0.42, p);
          const b3 = this.beats > 2 ? ease(0.58, 0.82, p) : 0;
          this.style.setProperty('--p', p.toFixed(3));
          this.style.setProperty('--b2', b2.toFixed(3));
          this.style.setProperty('--b3', b3.toFixed(3));
          const beat = p < 0.3 ? 1 : this.beats > 2 && p >= 0.66 ? 3 : 2;
          if (beat !== this.beat) {
            this.beat = beat;
            this.querySelectorAll('.hwx__beat').forEach((el) => {
              const on = Number(el.dataset.beat) === beat;
              el.classList.toggle('is-on', on);
              el.setAttribute('aria-hidden', on ? 'false' : 'true');
            });
          }
          this.querySelectorAll('.hwx__progress i').forEach((el, i) => {
            const a = i / this.beats, b = (i + 1) / this.beats;
            el.style.setProperty('--f', clamp((p - a) / (b - a)).toFixed(3));
          });
        }
        /* magic burst: once the world is on screen, the character pops in holding the product */
        finished() {
          if (this.classList.contains('is-done')) return;
          this.classList.add('is-done');
          document.dispatchEvent(new CustomEvent('living-world:done'));
        }
        reveal() {
          if (!this.classList.contains('hwx--burst')) {
            this.classList.add('is-revealed');
            return this.finished();
          }
          const go = () => {
            this.classList.add('is-bursting');
            const film = this.classList.contains('is-playing');
            setTimeout(() => { this.classList.add('is-revealed'); this.classList.remove('is-playing'); }, film ? 0 : 160);
            setTimeout(() => { this.classList.remove('is-bursting'); this.finished(); }, 1300);
          };
          const img = this.querySelector('.hwx__char-in img');
          const after = this.classList.contains('hwx--film') ? 60 : 350;
          const ready = () => setTimeout(go, after);
          if (!img || img.complete) ready();
          else { img.addEventListener('load', ready, { once: true }); img.addEventListener('error', ready, { once: true }); }
        }
        poke() {
          if (this.bubble && this.lines.length > 1) {
            this.line = (this.line + 1) % this.lines.length;
            this.bubble.textContent = this.lines[this.line];
            this.bubble.classList.remove('is-new');
            void this.bubble.offsetWidth;
            this.bubble.classList.add('is-new');
          }
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    document.addEventListener('pointermove', (e) => {
      const hero = e.target.closest && e.target.closest('.collection-hero');
      if (!hero) return;
      const r = hero.getBoundingClientRect();
      hero.style.setProperty('--ch-x', `${e.clientX - r.left}px`);
      hero.style.setProperty('--ch-y', `${e.clientY - r.top}px`);
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /* express checkout (Buy it now / Apple Pay / Shop Pay): inserted after the
     first interaction or ~3 s, then Shopify is asked to draw it */
  (() => {
    const slots = document.querySelectorAll('[data-deferred-pay]');
    if (!slots.length) return;
    let done = false;
    const go = () => {
      if (done) return;
      done = true;
      ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach((ev) => window.removeEventListener(ev, go, true));
      slots.forEach((slot) => {
        const t = slot.querySelector('template');
        if (t) slot.replaceChildren(t.content.cloneNode(true));
      });
      const init = () => window.Shopify?.PaymentButton?.init?.();
      init();
      setTimeout(init, 600);
    };
    ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach((ev) => window.addEventListener(ev, go, { once: true, passive: true, capture: true }));
    window.addEventListener('load', () => setTimeout(go, 3000), { once: true });
  })();
  /* stage: the tiles under/beside the photo take the shown color's tint */
  (() => {
    document.querySelectorAll('.product__gallery--stage').forEach((g) => {
      const sync = () => {
        const t = g.querySelector('.gallery__color.is-current .gallery__tint, .gallery__slide.is-current .gallery__tint') || g.querySelector('.gallery__tint');
        if (t) g.style.setProperty('--pick', t.style.getPropertyValue('--tint'));
      };
      sync();
      new MutationObserver(sync).observe(g, { subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  })();
  /* gallery: dots/thumbs follow the swipe; variants jump to their photo */
  (() => {
    document.querySelectorAll('[data-gallery]').forEach((track) => {
      const root = track.closest('.product__gallery');
      const slides = [...track.children];
      const thumbs = [...root.querySelectorAll('.gallery__thumb')];
      const index = root.querySelector('[data-gallery-index]');
      const fill = root.querySelector('[data-gallery-fill]');
      const caption = root.querySelector('[data-gallery-caption]');
      const dots = [...root.querySelectorAll('.gallery__dots span')];
      /* photos tagged for one color only show while that color is picked */
      const shown = () => slides.filter((sl) => !sl.hidden);
      let current = 0;
      const setActive = (i, force) => {
        if (i === current && !force) return;
        current = i;
        const el = shown()[i];
        const k = slides.indexOf(el);
        thumbs.forEach((t, n) => t.classList.toggle('is-active', n === k));
        dots.forEach((d, n) => d.classList.toggle('is-on', n === k));
        if (index) index.textContent = String(i + 1).padStart(2, '0');
        if (fill) fill.style.setProperty('--p', (i + 1) / shown().length);
        if (caption) caption.textContent = el?.dataset.caption || '';
      };
      const step = () => { const v = shown(); return v[1] ? v[1].offsetLeft - v[0].offsetLeft : track.clientWidth; };
      let raf = 0;
      track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => setActive(Math.min(shown().length - 1, Math.round(track.scrollLeft / step()))));
        },
        { passive: true }
      );
      const go = (i) => track.scrollTo({ left: i * step(), behavior: 'smooth' });
      thumbs.forEach((t, n) => t.addEventListener('click', () => go(Math.max(0, shown().indexOf(slides[n])))));
      const single = track.closest('.gallery--single');
      const colors = [...track.querySelectorAll('.gallery__color')];
      const filter = (options) => {
        if (!options) return;
        const pick = options.map((o) => String(o).toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''));
        let changed = false;
        slides.forEach((sl, n) => {
          if (!sl.dataset.only) return;
          const off = !sl.dataset.only.split(',').filter(Boolean).some((h) => pick.includes(h));
          if (sl.hidden !== off) changed = true;
          sl.hidden = off;
          if (thumbs[n]) thumbs[n].hidden = off;
          if (dots[n]) dots[n].hidden = off;
        });
        if (changed) { track.scrollLeft = 0; setActive(0, true); }
      };
      document.addEventListener('product:media', (e) => {
        if (e.detail.section && track.id && track.id !== 'Gallery-' + e.detail.section) return;
        filter(e.detail.options);
        /* story gallery: the color slide crossfades to that color, and we go back to it */
        if (colors.length) {
          const c = colors.find((el) => el.dataset.mediaId === String(e.detail.mediaId));
          if (!c) return;
          colors.forEach((el) => el.classList.toggle('is-current', el === c));
          const src = c.querySelector('img')?.currentSrc;
          const th = root.querySelector('[data-thumb-color]');
          if (src && th) {
            th.removeAttribute('srcset');
            th.src = src;
          }
          if (track.scrollLeft > 4) go(0);
          return;
        }
        const i = slides.findIndex((sl) => sl.dataset.mediaId === String(e.detail.mediaId));
        if (i < 0) return;
        if (single) slides.forEach((sl, k) => sl.classList.toggle('is-current', k === i));
        else go(i);
      });
    });

    /* product details as tabs: consecutive accordions become one tab set */
    document.querySelectorAll('product-form[data-details="tabs"]').forEach((form) => {
      const groups = [];
      [...form.children].forEach((el) => {
        if (!el.matches('details.accordion')) return;
        const prev = el.previousElementSibling;
        if (prev && prev.matches('details.accordion') && groups.length) groups[groups.length - 1].push(el);
        else groups.push([el]);
      });
      groups.filter((g) => g.length > 1).forEach((group, gi) => {
        const bar = document.createElement('div');
        bar.className = 'pb-tabs';
        bar.setAttribute('role', 'tablist');
        const show = (i) => {
          group.forEach((d, j) => {
            d.open = i === j;
            d.hidden = i !== j;
            bar.children[j].setAttribute('aria-selected', String(i === j));
          });
        };
        group.forEach((d, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('role', 'tab');
          b.textContent = d.querySelector('summary span:not(.accordion__sign)')?.textContent.trim() || '';
          b.addEventListener('click', () => show(i));
          bar.appendChild(b);
          d.classList.add('is-tab');
        });
        group[0].before(bar);
        show(0);
      });
    });

    /* sticky bar: shown once the main button has scrolled away */
    customElements.get('sticky-bar') ||
      customElements.define(
        'sticky-bar',
        class extends HTMLElement {
          connectedCallback() {
            const target = document.getElementById(this.dataset.watch);
            if (!target) return;
            this.hidden = false;
            /* floating buttons (help, gift) read --dock and sit above the bar */
            const dock = (on) => document.documentElement.style.setProperty('--dock', on ? `${this.offsetHeight}px` : '0px');
            new IntersectionObserver(([e]) => {
              /* away above; on phones also while it's still below the first screen */
              const on = !e.isIntersecting && (e.boundingClientRect.top < 0 || window.innerWidth < 990);
              this.toggleAttribute('data-visible', on);
              dock(on);
            }).observe(target);
          }
        }
      );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offer-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('offer-popup')) return;
    customElements.define(
      'offer-popup',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.key = this.dataset.key;
          this.querySelector('[data-copy]')?.addEventListener('click', (e) => this.copy(e.currentTarget));
          this.dialog.addEventListener('close', () => this.remember('closed'));
          const posted = JSON.parse(this.querySelector('[data-posted]').textContent || 'false');
          /* just signed up: reopen with the code */
          if (posted) {
            this.dialog.showModal();
            this.remember('done');
            this.maybeApply();
            return;
          }
          if (window.Shopify?.designMode) return;
          if (this.seen()) return;
          const d = this.dataset;
          const open = () => {
            if (this.opened || this.seen() || document.querySelector('dialog[open]')) return;
            this.opened = true;
            this.dialog.showModal();
            if (d.mode === 'code') this.maybeApply();
          };
          if (d.trigger === 'exit') {
            if (!window.matchMedia('(min-width: 990px) and (pointer: fine)').matches) return;
            setTimeout(() => document.addEventListener('mouseout', (e) => !e.relatedTarget && e.clientY < 10 && open()), 4000);
          } else if (d.trigger === 'scroll') {
            const onScroll = () => {
              const depth = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight;
              if (depth * 100 >= Number(d.scroll)) {
                window.removeEventListener('scroll', onScroll);
                open();
              }
            };
            window.addEventListener('scroll', onScroll, { passive: true });
          } else setTimeout(open, Number(d.delay) * 1000);
        }
        seen() {
          try {
            const v = JSON.parse(localStorage.getItem(this.key) || 'null');
            return v && Date.now() - v.at < Number(this.dataset.days) * 864e5;
          } catch (e) {
            return false;
          }
        }
        remember(state) {
          try {
            localStorage.setItem(this.key, JSON.stringify({ state, at: Date.now() }));
          } catch (e) {}
        }
        async maybeApply() {
          const code = this.dataset.code;
          if (!code || this.dataset.apply !== 'true') return;
          const root = (window.HALDEN?.routes?.root || '/').replace(/\/$/, '');
          try {
            await fetch(`${root}/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(`${root}/cart.js`)}`);
            const cart = await fetch(`${root}/cart.js`).then((r) => r.json());
            const ok = (cart.discount_codes || []).some((c) => c.code.toLowerCase() === code.toLowerCase());
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            const note = this.querySelector('[data-applied]');
            if (note) note.hidden = !ok;
          } catch (e) {}
        }
        async copy(button) {
          try {
            await navigator.clipboard.writeText(this.dataset.code);
            const was = button.textContent;
            button.textContent = this.dataset.copied;
            setTimeout(() => (button.textContent = was), 1800);
          } catch (e) {}
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-wall"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('review-wall')) return;
    customElements.define(
      'review-wall',
      class extends HTMLElement {
        connectedCallback() {
          this.cards = [...this.querySelectorAll('.rw__card')];
          this.step = Number(this.dataset.step) || 6;
          this.shown = this.step;
          this.filter = 'all';
          this.querySelectorAll('[data-filter]').forEach((b) =>
            b.addEventListener('click', () => {
              this.querySelectorAll('[data-filter]').forEach((x) => x.classList.toggle('is-active', x === b));
              this.filter = b.dataset.filter;
              this.shown = this.step;
              this.render();
            })
          );
          this.querySelector('[data-more]')?.addEventListener('click', () => {
            this.shown += this.step;
            this.render();
          });
          this.render();
        }
        render() {
          const match = (c) => this.filter === 'all' || (this.filter === 'photo' ? c.hasAttribute('data-photo') : c.dataset.rating === this.filter);
          const list = this.cards.filter(match);
          this.cards.forEach((c) => (c.hidden = true));
          list.slice(0, this.shown).forEach((c) => (c.hidden = false));
          const more = this.querySelector('.rw__more');
          if (more) more.hidden = list.length <= this.shown;
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scratch-popup"] && !Shopify.designMode) return;
  try {
    
  /* Waits quietly; loads the scratch engine only when it's time to open. */
  (() => {
    if (customElements.get('scratch-card')) return;
    const KEY = 'halden:scratch';
    const store = {
      get() {
        try {
          return JSON.parse(localStorage.getItem(KEY) || 'null');
        } catch (e) {
          return null;
        }
      },
      set(v) {
        try {
          localStorage.setItem(KEY, JSON.stringify(v));
        } catch (e) {}
      },
    };
    customElements.define(
      'scratch-card',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          this.teaser = this.querySelector('[data-teaser]');
          this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.close()));
          this.dialog.addEventListener('cancel', (e) => {
            e.preventDefault();
            this.close();
          });
          this.dialog.addEventListener('click', (e) => e.target === this.dialog && this.close());
          this.teaser?.addEventListener('click', () => this.open(true));
          /* the teaser tucks away while the buying area, the hero words or the
             footer pass through its corner, so it never covers content */
          if (this.teaser && 'IntersectionObserver' in window) {
            const busy = new Set();
            const io = new IntersectionObserver(
              (entries) => {
                entries.forEach((e) => (e.isIntersecting ? busy.add(e.target) : busy.delete(e.target)));
                this.teaser.classList.toggle('is-tucked', busy.size > 0);
              },
              { rootMargin: '-86% 0px 0px 0px' }
            );
            const watch = () => document.querySelectorAll('.hs__copy, .hlx__copy, .product__info, .footer, .cart-page, [data-teaser-avoid]').forEach((el) => io.observe(el));
            watch();
          }
          if (this.hasAttribute('data-preview')) return;
          const state = store.get();
          const days = Number(this.dataset.days);
          if (days === 0) {
            /* 0 days: opens on every new visit, once per browser session */
            let seen = false;
            try {
              seen = !!sessionStorage.getItem(KEY + ':seen');
            } catch (e) {}
            if (seen) return this.showTeaser();
          } else {
            if (state?.revealed) return this.showTeaser(state);
            if (state?.closed && Date.now() - state.closed < (days || 7) * 864e5) return this.showTeaser();
          }
          this.arm();
        }
        arm() {
          const go = () => this.open();
          /* product pages: 'off' only shows the reopen tab, 'calm' waits longer and ignores scrolling */
          const mode = this.dataset.product;
          if (mode === 'off') return this.showTeaser();
          const calm = mode === 'calm';
          /* a living world hero plays its opening first; the game pops up right after it */
          const hero = document.querySelector('living-world');
          if (hero && !hero.classList.contains('is-done') && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
            /* never before the opening has finished, and never before "After" seconds have passed */
            const t0 = performance.now();
            const wait = (Number(this.dataset.delay) || 2) * 1000;
            this.onHero = () => { clearTimeout(this.timer); this.timer = setTimeout(go, Math.max(1200, wait - (performance.now() - t0))); };
            document.addEventListener('living-world:done', this.onHero, { once: true });
            this.timer = setTimeout(go, 15000);
          } else {
            const delay = Number(this.dataset.delay) || 2;
            this.timer = setTimeout(go, (calm ? Math.max(30, delay) : delay) * 1000);
          }
          const goal = calm ? 2 : (Number(this.dataset.scroll) || 55) / 100;
          this.onScroll = () => {
            const max = document.documentElement.scrollHeight - innerHeight;
            if (max > 0 && scrollY / max >= goal) go();
          };
          addEventListener('scroll', this.onScroll, { passive: true });
          if (this.dataset.exit === 'true' && matchMedia('(hover: hover) and (pointer: fine)').matches) {
            this.onLeave = (e) => !e.relatedTarget && e.clientY <= 0 && go();
            document.addEventListener('mouseout', this.onLeave);
          }
        }
        disarm() {
          clearTimeout(this.timer);
          if (this.onHero) document.removeEventListener('living-world:done', this.onHero);
          removeEventListener('scroll', this.onScroll);
          if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
        }
        async open(manual) {
          if (this.dialog.open) return;
          if (!manual) {
            /* it pops up by itself once per visit; after that only the teaser opens it */
            if (this.shown) return;
            try {
              if (sessionStorage.getItem(KEY + ':seen')) return;
            } catch (e) {}
            /* every automatic trigger (timer, scroll, exit, hero, cookie banner) waits
               at least "After" seconds from the moment the visitor arrived */
            const left = (Number(this.dataset.delay) || 2) * 1000 - performance.now();
            if (left > 0) {
              clearTimeout(this.timer);
              this.timer = setTimeout(() => this.open(), left + 50);
              return;
            }
          }
          /* never over an open cart or menu, nor over a cookie banner still waiting for an answer */
          const cookie = document.getElementById('shopify-pc__banner');
          const cookieUp = (cookie && cookie.offsetParent !== null && getComputedStyle(cookie).visibility !== 'hidden') || document.querySelector('cookie-bar:not([hidden])');
          if (!manual && (document.querySelector('dialog[open]') || cookieUp)) {
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.open(), cookieUp ? 1500 : 6000);
            return;
          }
          this.disarm();
          this.shown = true;
          try {
            sessionStorage.setItem(KEY + ':seen', '1');
          } catch (e) {}
          if (this.teaser) this.teaser.hidden = true;
          await import(this.dataset.src).catch(() => {});
          this.dialog.showModal();
          window.HaldenScratch?.mount(this);
        }
        close() {
          this.dialog.close();
          const state = store.get() || {};
          if (!state.revealed) store.set({ closed: Date.now() });
          this.showTeaser(store.get());
        }
        showTeaser() {
          if (this.teaser) this.teaser.hidden = false;
        }
        onSelect() {
          this.open(true);
        }
      }
    );
    document.addEventListener('shopify:section:select', (e) => e.target.querySelector?.('scratch-card')?.open(true));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats-showcase"] && !Shopify.designMode) return;
  try {
    
  /* dot field: canvas, drawn only while on screen, capped pixel ratio */
  (() => {
    if (customElements.get('dot-field')) return;
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    customElements.define(
      'dot-field',
      class extends HTMLElement {
        connectedCallback() {
          this.canvas = this.querySelector('canvas');
          this.ctx = this.canvas.getContext('2d');
          this.color = getComputedStyle(this).getPropertyValue('--dot-color').trim() || '#ffffff';
          this.mouse = { x: -9999, y: -9999, on: false };
          this.ripples = [];
          this.running = false;
          this.resize();
          new ResizeObserver(() => this.resize()).observe(this);
          new IntersectionObserver(([e]) => (e.isIntersecting ? this.start() : this.stop())).observe(this);
          const stage = this.parentElement;
          const at = (e) => {
            const r = this.getBoundingClientRect();
            return { x: e.clientX - r.left, y: e.clientY - r.top };
          };
          if (window.matchMedia('(pointer: coarse)').matches) {
            this.coarse = true;
          }
          stage.addEventListener('pointermove', (e) => !this.coarse && Object.assign(this.mouse, at(e), { on: true }));
          stage.addEventListener('pointerleave', () => (this.mouse.on = false));
          /* phones: a tap (not a scroll) sends a ripple through the dots; the
             field animates only while a ripple is moving, then rests again */
          stage.addEventListener('click', (e) => {
            if (!this.coarse || calm) return;
            this.ripples = this.ripples.slice(-2);
            this.ripples.push({ ...at(e), t: performance.now() });
            navigator.vibrate?.(8);
            this.burst();
          });
          stage.addEventListener('pointerdown', (e) => {
            if (this.coarse) return;
            this.ripples.push({ ...at(e), t: performance.now() });
            Object.assign(this.mouse, at(e), { on: true, down: true });
          });
          window.addEventListener('pointerup', () => (this.mouse.down = false));
          if (calm) this.draw(0);
        }
        resize() {
          const coarse = window.matchMedia('(pointer: coarse)').matches;
          this.coarse = coarse;
          const dpr = coarse ? 1 : Math.min(1.5, window.devicePixelRatio || 1);
          const r = this.getBoundingClientRect();
          /* only real size changes reallocate the canvas */
          if (Math.abs(r.width - (this.w || 0)) < 1 && Math.abs(r.height - (this.h || 0)) < 1) return;
          this.w = r.width;
          this.h = r.height;
          this.canvas.width = Math.round(r.width * dpr);
          this.canvas.height = Math.round(r.height * dpr);
          this.ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
          this.gap = r.width < 700 ? 26 : 26;
          if (calm || (this.coarse && this.drawn)) this.draw(0);
        }
        burst() {
          if (this.bursting) return;
          this.bursting = true;
          let last = 0;
          const loop = (t) => {
            if (t - last >= 33) {
              last = t;
              this.draw(t);
            }
            if (this.ripples.length) requestAnimationFrame(loop);
            else {
              this.bursting = false;
              this.draw(t);
            }
          };
          requestAnimationFrame(loop);
        }
        start() {
          /* phones and tablets: the dot field is drawn once and stays still
             (the soft color fields still drift), so it can never stutter */
          if (this.coarse) {
            if (!this.drawn) {
              this.drawn = true;
              this.draw(0);
            }
            return;
          }
          if (this.running || calm) return;
          this.running = true;
          /* phones: 30 frames a second is plenty for a slow wave */
          const step = this.coarse ? 33 : 0;
          let last = 0;
          const loop = (t) => {
            if (!this.running) return;
            if (t - last >= step) {
              last = t;
              this.draw(t);
            }
            this.raf = requestAnimationFrame(loop);
          };
          this.raf = requestAnimationFrame(loop);
        }
        stop() {
          this.running = false;
          cancelAnimationFrame(this.raf);
        }
        draw(t) {
          const { ctx, w, h, gap, mouse } = this;
          ctx.clearRect(0, 0, w, h);
          ctx.fillStyle = this.color;
          /* phones keep the resting wave still; only ripples move */
          const scroll = this.coarse ? 0 : window.scrollY * 0.004;
          const wt = this.coarse ? 0 : t * 0.0012;
          const R = 170;
          this.ripples = this.ripples.filter((r) => t - r.t < 1600);
          const near = mouse.on;
          const rip = this.ripples.length > 0;
          /* dots are batched by brightness: ten fills a frame instead of one per dot */
          const paths = Array.from({ length: 10 }, () => new Path2D());
          for (let y = gap / 2; y < h; y += gap) {
            for (let x = gap / 2; x < w; x += gap) {
              /* idle: a slow diagonal wave, pushed along by the scroll */
              const wave = Math.sin(x * 0.012 + y * 0.018 + wt + scroll);
              let a = 0.3 + 0.2 * wave;
              let s = 1.35 + 0.35 * wave;
              let dx = 0;
              let dy = 0;
              if (near) {
                const mx = x - mouse.x;
                const my = y - mouse.y;
                if (mx < R && mx > -R && my < R && my > -R) {
                  const d = Math.hypot(mx, my);
                  if (d < R) {
                    const k = 1 - d / R;
                    a += k * 0.85;
                    s += k * 2.6;
                    const pull = mouse.down ? -26 : 14;
                    dx = (mx / (d || 1)) * k * pull;
                    dy = (my / (d || 1)) * k * pull;
                  }
                }
              }
              if (rip) {
                for (const r of this.ripples) {
                  const age = (t - r.t) / 1600;
                  const band = Math.abs(Math.hypot(x - r.x, y - r.y) - age * 520);
                  const wide = this.coarse ? 48 : 36;
                  if (band < wide) {
                    const k = (1 - band / wide) * (1 - age);
                    a += k * (this.coarse ? 1.6 : 0.9);
                    s += k * (this.coarse ? 3.4 : 2.2);
                  }
                }
              }
              const p = paths[Math.min(9, Math.floor(Math.min(1, a) * 10))];
              const cx = x + dx, cy = y + dy;
              if (s < 2.2) p.rect(cx - s, cy - s, s * 2, s * 2);
              else {
                p.moveTo(cx + s, cy);
                p.arc(cx, cy, s, 0, 6.2832);
              }
            }
          }
          paths.forEach((p, i) => {
            ctx.globalAlpha = (i + 0.5) / 10;
            ctx.fill(p);
          });
          ctx.globalAlpha = 1;
        }
        disconnectedCallback() {
          this.stop();
        }
      }
    );
  })();

  /* the stage grows to full width while it enters the screen */
  (() => {
    if (customElements.get('stats-stage')) return;
    const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    customElements.define(
      'stats-stage',
      class extends HTMLElement {
        connectedCallback() {
          if (calm) return;
          let on = false;
          let ticking = false;
          const paint = () => {
            ticking = false;
            const r = this.getBoundingClientRect();
            const vh = window.innerHeight;
            const e = Math.max(0, Math.min(1, (vh - r.top) / (vh * 0.75)));
            this.style.setProperty('--e', e.toFixed(3));
          };
          new IntersectionObserver(([x]) => {
            on = x.isIntersecting;
            if (on) paint();
          }, { rootMargin: '0px 0px 20% 0px' }).observe(this);
          window.addEventListener('scroll', () => on && !ticking && (ticking = true) && requestAnimationFrame(paint), { passive: true });
          this.style.setProperty('--e', 0);
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["steps"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('steps-pin')) return;
    customElements.define(
      'steps-pin',
      class extends HTMLElement {
        connectedCallback() {
          const imgs = [...this.querySelectorAll('.pin__img')];
          const steps = [...this.querySelectorAll('.pin__step')];
          const num = this.querySelector('[data-num]');
          const fill = this.querySelector('[data-fill]');
          let active = 0;
          const set = (i) => {
            if (i === active) return;
            active = i;
            imgs.forEach((el, k) => {
              el.classList.toggle('is-on', k === i);
              el.classList.toggle('is-past', k < i);
            });
            steps.forEach((el, k) => el.classList.toggle('is-on', k === i));
            num.textContent = String(i + 1).padStart(2, '0');
          };
          /* the step that crosses the middle of the screen is the active one */
          const io = new IntersectionObserver(
            (entries) => entries.forEach((e) => e.isIntersecting && set(Number(e.target.dataset.mark))),
            { rootMargin: '-50% 0px -50% 0px' }
          );
          this.querySelectorAll('[data-mark]').forEach((m) => io.observe(m));
          /* progress line: only computed while the section is on screen */
          let on = false;
          let ticking = false;
          const paint = () => {
            ticking = false;
            const r = this.getBoundingClientRect();
            const span = r.height - window.innerHeight;
            fill.style.setProperty('--p', Math.max(0, Math.min(1, -r.top / (span || 1))));
          };
          new IntersectionObserver(([e]) => (on = e.isIntersecting)).observe(this);
          window.addEventListener('scroll', () => on && !ticking && (ticking = true) && requestAnimationFrame(paint), { passive: true });
          /* theme editor: selecting a step block scrolls to it */
          document.addEventListener('shopify:block:select', (e) => {
            const i = imgs.indexOf(e.target);
            if (i >= 0) this.querySelector(`[data-mark="${i}"]`)?.scrollIntoView({ block: 'center' });
          });
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('story-wheel')) return;
    /* story wheel: cards roll through a 3D wheel; auto-rolls, pauses on each story; swipe, drag or buttons */
    customElements.define('story-drip', class extends HTMLElement {
      connectedCallback() {
        this.built = new Set();
        const build = () => this.querySelectorAll('[data-wall]').forEach((wall) => this.fill(wall));
        build();
        matchMedia('(min-width: 990px)').addEventListener?.('change', build);
        /* runs only while on screen */
        new IntersectionObserver(([e]) => this.classList.toggle('is-on', e.isIntersecting), { rootMargin: '80px 0px' }).observe(this);
        /* touch and hold pauses it, to read a story */
        this.addEventListener('pointerdown', (e) => e.pointerType !== 'mouse' && this.classList.add('is-held'));
        ['pointerup', 'pointercancel', 'pointerleave'].forEach((n) => this.addEventListener(n, () => this.classList.remove('is-held')));
      }
      /* repeat each column's stories until it is taller than the wall, then once more for the seamless loop */
      fill(wall) {
        if (this.built.has(wall) || !wall.offsetHeight) return;
        this.built.add(wall);
        const copy = (node) => {
          const c = node.cloneNode(true);
          c.setAttribute('aria-hidden', 'true');
          c.removeAttribute('data-shopify-editor-block');
          c.querySelectorAll('[id]').forEach((x) => x.removeAttribute('id'));
          c.querySelectorAll('a, button, video').forEach((x) => x.setAttribute('tabindex', '-1'));
          return c;
        };
        wall.querySelectorAll('[data-run]').forEach((run) => {
          const base = [...run.children];
          if (!base.length) return;
          let guard = 0;
          while (run.scrollHeight < wall.offsetHeight + 40 && guard++ < 12) base.forEach((n) => run.appendChild(copy(n)));
          [...run.children].forEach((n) => run.appendChild(copy(n)));
        });
      }
    });
    customElements.define('story-wheel', class extends HTMLElement {
      /* story wheel: cards roll continuously through a 3D wheel (like a card carousel);
         slows on hover/touch, drag or swipe to spin, buttons step one story */
      connectedCallback() {
        this.cards = [...this.querySelectorAll('.story__card')];
        const n = this.cards.length;
        if (!n) return;
        const calm = matchMedia('(prefers-reduced-motion: reduce)').matches;
        const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
        const speed = 1 / (Number(this.dataset.seconds) || 4);
        this.pos = 0;
        this.target = null;
        const place = () => {
          this.cards.forEach((c, i) => {
            let d = ((i - this.pos) % n + n) % n;
            if (d > n / 2) d -= n;
            const ad = Math.min(3, Math.abs(d));
            c.style.setProperty('--d', d.toFixed(3));
            c.style.setProperty('--ad', ad.toFixed(3));
            c.style.setProperty('--z', String(100 - Math.round(ad * 10)));
            c.style.visibility = ad > 2.6 ? 'hidden' : '';
            c.classList.toggle('is-front', ad < 0.5);
            c.inert = ad >= 0.5;
          });
        };
        const step = (k) => { this.target = Math.round(this.pos) + k; };
        this.querySelectorAll('[data-step]').forEach((b) => b.addEventListener('click', () => step(Number(b.dataset.step))));
        new IntersectionObserver(([e]) => { this.on = e.isIntersecting; if (e.isIntersecting) this.classList.add('is-in'); }, { threshold: 0.25 }).observe(this);
        place();
        if (calm) {
          this.classList.add('is-in');
          this.querySelectorAll('[data-step]').forEach((b) => b.addEventListener('click', () => { this.pos = this.target; place(); }));
          return;
        }
        /* drag / swipe spins the wheel; phones swipe sideways so the page still scrolls vertically */
        let drag = null;
        this.addEventListener('pointerdown', (e) => {
          if (e.target.closest('a,button,input')) return;
          drag = { x: e.clientX, y: e.clientY, p: this.pos, moved: false };
          this.target = null;
        });
        addEventListener('pointermove', (e) => {
          if (fine) {
            const r = this.getBoundingClientRect();
            this.style.setProperty('--tx', (((e.clientX - r.left) / r.width) * 2 - 1).toFixed(3));
            this.style.setProperty('--ty', (((e.clientY - r.top) / r.height) * 2 - 1).toFixed(3));
          }
          if (!drag) return;
          const dy = e.clientY - drag.y, dx = e.clientX - drag.x;
          const amt = e.pointerType === 'mouse' ? -dy / 160 : -dx / 140;
          if (Math.abs(amt) > 0.03) { drag.moved = true; this.classList.add('is-dragging'); }
          this.pos = drag.p + amt;
          place();
        }, { passive: true });
        addEventListener('pointerup', () => {
          if (!drag) return;
          if (drag.moved) this.target = Math.round(this.pos);
          drag = null;
          this.classList.remove('is-dragging');
        });
        this.addEventListener('pointerenter', () => (this.hover = true));
        this.addEventListener('pointerleave', () => { this.hover = false; this.style.setProperty('--tx', 0); this.style.setProperty('--ty', 0); });
        let last = performance.now(), v = speed;
        const tick = (now) => {
          requestAnimationFrame(tick);
          const dt = Math.min(0.05, (now - last) / 1000);
          last = now;
          if (!this.on || drag) return;
          if (this.target !== null) {
            const diff = this.target - this.pos;
            this.pos += diff * Math.min(1, dt * 7);
            if (Math.abs(diff) < 0.002) { this.pos = this.target; this.target = null; }
          } else {
            const want = this.hover ? speed * 0.15 : speed;
            v += (want - v) * Math.min(1, dt * 3);
            this.pos += v * dt;
          }
          place();
        };
        requestAnimationFrame(tick);
      }
    });
  })();

  (() => {
    if (customElements.get('ugc-story')) return;
    customElements.define(
      'ugc-story',
      class extends HTMLElement {
        connectedCallback() {
          const track = this.querySelector('[data-track]');
          const bars = [...this.querySelectorAll('.story__bar span')];
          /* progress bars follow the swipe: full for cards passed, partial for the one in view */
          let ticking = false;
          const paint = () => {
            ticking = false;
            const card = track.firstElementChild;
            if (!card) return;
            const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
            const pos = track.scrollLeft / step + (track.clientWidth / step - 1);
            bars.forEach((b, i) => b.style.setProperty('--fill', Math.max(0, Math.min(1, pos - i + 1))));
          };
          track.addEventListener('scroll', () => !ticking && (ticking = true) && requestAnimationFrame(paint), { passive: true });
          paint();
          /* clips: tap to play / pause, only one at a time */
          this.querySelectorAll('[data-play]').forEach((b) =>
            b.addEventListener('click', () => {
              const media = b.closest('.story__media');
              const video = media.querySelector('video');
              if (!video) return;
              if (video.paused) {
                this.querySelectorAll('video').forEach((v) => v !== video && v.pause());
                video.play().catch(() => {});
              } else video.pause();
              this.querySelectorAll('.story__media').forEach((m) => m.classList.toggle('is-playing', !m.querySelector('video')?.paused));
            })
          );
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reels"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('video-reels')) return;
    customElements.define(
      'video-reels',
      class extends HTMLElement {
        connectedCallback() {
          const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
          const videos = [...this.querySelectorAll('video')];
          videos.forEach((v) => {
            v.addEventListener('click', () => (v.paused ? v.play() : v.pause()));
          });
          if (reduce || !('IntersectionObserver' in window)) return;
          const io = new IntersectionObserver(
            (entries) =>
              entries.forEach((e) => {
                const v = e.target;
                if (e.isIntersecting && e.intersectionRatio > 0.6) {
                  v.preload = 'auto';
                  v.play().catch(() => {});
                } else v.pause();
              }),
            { threshold: [0, 0.6, 1] }
          );
          videos.forEach((v) => io.observe(v));
        }
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
